import { gsap } from '../global/gsap';
import onScrollDirection from '../utilities/scroll-direction';

const initHeader = (header) => {
    const body = document.querySelector('.js-body');
    const logo = header.querySelector('.header__site-link');
    const pinnedClass = 'header-pinned';
    let isPinned = false;
    let locked = false;

    // Get offset to reveal once scrolled beyond header, read from global CSS var
    const getOffset = () => parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10);

    let offset = getOffset();

    window.addEventListener('resize', () => {
        offset = getOffset();
    });

    const show = () => {
        if (isPinned) return;

        isPinned = true;
        body.classList.add(pinnedClass);

        gsap.fromTo(logo,
            {
                y: '-100%'
            },
            {
                y: 0,
                duration: 0.25,
                ease: 'power3',
                overwrite: true
            }
        );
    };

    const hide = () => {
        if (!isPinned) return;

        isPinned = false;

        gsap.to(logo, {
            y: '-100%',
            duration: 0.25,
            ease: 'power3',
            overwrite: true,
            onComplete: () => {
                body.classList.remove(pinnedClass);
                gsap.set(logo, { clearProps: 'transform' });
            }
        });
    };

    // Stop logo re-animating at very top
    const reset = () => {
        if (!isPinned) return;
        isPinned = false;
        gsap.killTweensOf(logo);
        gsap.set(logo, { clearProps: 'transform' });
        body.classList.remove(pinnedClass);
    };

    // Clear pinned state and ignore scroll events (used while the menu is open
    // so the scroll-restore jump on close doesn't re-pin the header)
    const lock = () => {
        locked = true;
        reset();
    };

    const unlock = () => {
        locked = false;
    };

    // Direction logic
    onScrollDirection((direction, scroll) => {
        if (locked) return;

        if (scroll <= 0) {
            reset();
        } else if (direction === 1) {
            hide();
        } else if (direction === -1 && scroll > offset) {
            show();
        }
    });

    return { show, hide, reset, lock, unlock };
};

export { initHeader as default };
